import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'IndispoView',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/IndispoView/IndispoView.vue'),
    },
    {
      name: 'MroadCalendarTrancheUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MroadCalendarTrancheUI/MroadCalendarTrancheUI.vue'),
    },
    {
      name: 'MroadCalendarUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MroadCalendarUI/MroadCalendarUI.vue'),
    },
    {
      name: 'MroadDetailUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MroadDetailUI/MroadDetailUI.vue'),
    },
    {
      name: 'MroadEventUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MroadEventUI/MroadEventUI.vue'),
    },
    {
      name: 'MroadOrderUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MroadOrderUI/MroadOrderUI.vue'),
    },
  ],
}
